import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_CONTEXT = {
	name: "OBSERVATION_CONTEXT",
	concept: {
		PERSONAL_CARE: {
			display: {
				"nl-BE": "Tijdens persoonlijke verzorging",
				"fr-BE": "Lors des soins personnels",
			},
		},
		MEDICAL_EXAMINATION: {
			display: {
				"nl-BE": "Tijdens medisch onderzoek of interventie",
				"fr-BE": "Lors d'un examen médical ou d'une intervention",
			},
		},
		WALK: {
			display: {
				"nl-BE": "Tijdens verplaatsing",
				"fr-BE": "Lors d'un déplacement",
			},
		},
		WAY_TO_TOILET: {
			display: {
				"nl-BE": "Tijdens het proberen bereiken van het toilet",
				"fr-BE": "En essayant d'atteindre les toilettes",
			},
		},
		ACTIVITY_PARTICIPATION: {
			display: {
				"nl-BE": "Tijdens deelname aan een activiteit",
				"fr-BE": "Lors d'une activité",
			},
		},
		SIT: {
			display: {
				"nl-BE": "Tijdens rustig zitten",
				"fr-BE": "En position assise",
			},
		},
		LEGACY_SLEEP: {
			display: {
				"nl-BE": "Tijdens de slaap",
				"fr-BE": "Pendant le sommeil",
			},
		},
		COGNITIVE_CONFUSION: {
			display: {
				"nl-BE": "Tijdens cognitieve verwarring",
				"fr-BE": "En cas de confusion cognitive",
			},
		},
		COUGH_LAUGH_SNEEZE: {
			display: {
				"nl-BE": "Tijdens hoesten, lachen of niezen",
				"fr-BE": "En cas de toux, rire ou éternuement",
			},
		},
		VISIT: {
			display: {
				"nl-BE": "Bezoek ontvangen",
				"fr-BE": "Recevoir une visite",
			},
		},
		EAT: {
			display: {
				"nl-BE": "Eten",
				"fr-BE": "Manger",
			},
		},
		BED_ENTER: {
			display: {
				"nl-BE": "In bed gaan liggen",
				"fr-BE": "Se coucher",
			},
		},
		BED_EXIT: {
			display: {
				"nl-BE": "Uit bed komen",
				"fr-BE": "Sortir du lit",
			},
		},
		BEND: {
			display: {
				"nl-BE": "Vooroverbuigen",
				"fr-BE": "Se pencher",
			},
		},

		HELPING: {
			display: {
				"nl-BE": "Hulp bieden aan anderen",
				"fr-BE": "Aider les autres",
			},
		},
		REACH: {
			display: {
				"nl-BE": "Reiken",
				"fr-BE": "Atteindre",
			},
		},

		STAND: {
			display: {
				"nl-BE": "Opstaan",
				"fr-BE": "Se lever",
			},
		},
		STEP: {
			display: {
				"nl-BE": "Stappen",
				"fr-BE": "Marcher",
			},
		},
	},
} as const satisfies CodeSystem;
